<template lang='pug' src='./nav-desktop.pug'></template>

<script>
import Icon from 'components/icon/icon'

import { toForm } from '@/methods'

export default {
  props: ['props'],
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  mixins: [toForm],
  components: {
    Icon
  }
}

</script>



// WEBPACK FOOTER //
// nav-desktop.vue?572521ad